module.exports = __webpack_public_path__ + "docs/templates-1.3.pdf";